/* Shared photo browser for the modern templates (rc9 tpl-lightbox). Enhances picture links in .mp-pics (Galerie page),
   .ms-gallery__grid (Bilder section) and any picture link with [data-mp-lightbox] (kinetik gallery; its group is the surrounding list): <dialog> lightbox with prev/next, counter, caption, touch swipe, arrows / Home / End,
   Esc, native focus trap (showModal), focus returns to the opener, reduced motion respected. Without JS the links open the image. */
(function () {
	'use strict';
	if (window.__mpLightbox) return;
	window.__mpLightbox = true;
	var doc = document;
	var en = /^en/i.test(doc.documentElement.lang || '');
	var T = en
		? { dlg: 'Photo browser', prev: 'Previous picture', next: 'Next picture', close: 'Close', of: function (i, n) { return 'Picture ' + i + ' of ' + n; } }
		: { dlg: 'Bildbetrachter', prev: 'Vorheriges Bild', next: 'Nächstes Bild', close: 'Schließen', of: function (i, n) { return 'Bild ' + i + ' von ' + n; } };
	var GROUPS = '.mp-pics, .ms-gallery__grid';
	var HOOK = 'a[data-mp-lightbox][href]';   // any link carrying the hook; its group = the surrounding list (kinetik gallery)
	var dlg, img, cap, count, set = [], idx = 0, opener = null, startX = null, startY = null;

	function el(tag, cls, attrs) {
		var e = doc.createElement(tag); if (cls) e.className = cls;
		for (var k in (attrs || {})) e.setAttribute(k, attrs[k]);
		return e;
	}
	/* fixed SVG icons (not text glyphs): glyph side bearings and baselines made the icons sit off-centre, most visibly in Firefox */
	function icon(d) {
		return '<svg class="mp-lb__icon" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
	}
	/* Browsers without <dialog>.showModal (Safari before 15.4): the open attribute plus our own Tab cycle (same pattern as js/consent.js) */
	function openDlg() { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
	function closeDlg() {
		if (dlg.close) dlg.close();
		else if (dlg.hasAttribute('open')) { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); }
	}
	function build() {
		dlg = el('dialog', 'mp-lb', { 'aria-label': T.dlg });
		var fig = el('figure', 'mp-lb__fig');
		img = el('img', 'mp-lb__img', { alt: '' });
		cap = el('figcaption', 'mp-lb__cap');
		count = el('p', 'mp-lb__count', { 'aria-live': 'polite' });
		fig.appendChild(img); fig.appendChild(cap);
		var close = el('button', 'mp-lb__btn mp-lb__close', { type: 'button', 'data-act': 'close', 'aria-label': T.close }); close.innerHTML = icon('M6 6l12 12M18 6L6 18');
		var prev = el('button', 'mp-lb__btn mp-lb__prev', { type: 'button', 'data-act': 'prev', 'aria-label': T.prev }); prev.innerHTML = icon('M15 5l-7 7 7 7');
		var next = el('button', 'mp-lb__btn mp-lb__next', { type: 'button', 'data-act': 'next', 'aria-label': T.next }); next.innerHTML = icon('M9 5l7 7-7 7');
		dlg.appendChild(fig); dlg.appendChild(count); dlg.appendChild(prev); dlg.appendChild(next); dlg.appendChild(close);
		doc.body.appendChild(dlg);
		dlg.addEventListener('click', function (e) {
			var tg = /** @type {any} */ (e.target); var a = tg.closest && tg.closest('[data-act]');
			if (a) { var act = a.getAttribute('data-act'); if (act === 'close') closeDlg(); else step(act === 'next' ? 1 : -1); }
			else if (e.target === dlg) closeDlg();   // backdrop
		});
		dlg.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeDlg(); return; }   // own Esc: page handlers (lumen's menu) preventDefault the native close
			if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
			else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
			else if (e.key === 'Home') { e.preventDefault(); show(0); }
			else if (e.key === 'End') { e.preventDefault(); show(set.length - 1); }
			else if (e.key === 'Tab' && !dlg.showModal) {   // native showModal traps the focus itself
				var btns = [].filter.call(dlg.querySelectorAll('button'), function (b) { return !b.hidden; });
				if (!btns.length) return;
				var at = btns.indexOf(/** @type {any} */ (doc.activeElement)), n = e.shiftKey ? (at <= 0 ? btns.length - 1 : at - 1) : (at < 0 || at === btns.length - 1 ? 0 : at + 1);
				e.preventDefault(); btns[n].focus();
			}
		});
		dlg.addEventListener('touchstart', function (e) { var t = e.touches[0]; startX = t.clientX; startY = t.clientY; }, { passive: true });
		dlg.addEventListener('touchend', function (e) {
			if (startX === null) return;
			var t = e.changedTouches[0], dx = t.clientX - startX, dy = t.clientY - startY; startX = null;
			if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
		}, { passive: true });
		dlg.addEventListener('close', function () {
			doc.documentElement.classList.remove('mp-lb-open');
			if (opener && opener.focus) opener.focus();
		});
	}
	function step(d) { show(idx + d); }
	function show(i) {
		idx = (i + set.length) % set.length;
		var a = set[idx], thumb = a.querySelector('img');
		img.src = a.href;
		img.alt = thumb ? thumb.alt : '';
		var c = a.getAttribute('data-caption') || (thumb && thumb.alt) || '';
		var sib = a.parentElement && a.parentElement.querySelector('.ms-gallery__caption');
		cap.textContent = (sib && sib.textContent.trim()) || c;
		cap.hidden = !cap.textContent;
		count.textContent = T.of(idx + 1, set.length);
		var multi = set.length > 1;
		[].forEach.call(dlg.querySelectorAll('[data-act="prev"],[data-act="next"]'), function (b) { b.hidden = !multi; });
	}
	doc.addEventListener('click', function (e) {
		if (e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;
		var tg = /** @type {any} */ (e.target); var a = tg.closest && tg.closest(GROUPS.split(',').map(function (g) { return g.trim() + ' a[href]'; }).concat(HOOK).join(','));
		if (!a || !a.querySelector('img')) return;
		e.preventDefault();
		if (!dlg) build();
		var hooked = a.hasAttribute('data-mp-lightbox');
		var grp = hooked ? (a.closest('ul, ol') || a.parentElement) : a.closest(GROUPS);
		set = [].filter.call(grp.querySelectorAll(hooked ? HOOK : 'a[href]'), function (x) { return x.querySelector('img'); });
		opener = a;
		show(set.indexOf(a));
		openDlg();
		doc.documentElement.classList.add('mp-lb-open');
		dlg.querySelector('[data-act="close"]').focus();
	});
})();
